/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { InjectionToken } from '@angular/core';

export interface PageEnvironment {
  name: string;
}

export interface PageEnvironmentProvider {
  environment: PageEnvironment;
}

export const PAGE_ENVIRONMENT_PROVIDER = new InjectionToken<PageEnvironmentProvider>('PAGE_ENVIRONMENT_PROVIDER');
// tslint:disable-next-line:max-line-length
export const PAGE_ENVIRONMENT_STYLE_FACTORIES = new InjectionToken<Hash<TransformFn<PageEnvironment, string>>>(
  'PageEnvironmentStyles');

export const UNKNOWN_PAGE_ENVIRONMENT: PageEnvironment = { name: 'unknown' };
